import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=0c4e8f1d&"
import script from "./editTask.vue?vue&type=script&lang=js&"
export * from "./editTask.vue?vue&type=script&lang=js&"
import style0 from "./editTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports